import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass/styled-components';
import { calculateWidth } from '../../../utils/calculateColumnWidth';
import { componentMapping } from '../../../utils/helpers';

const PromoCardGrid = ({
  columns,
  page,
  groupRowTitle = '',
  restrictContent = true,
}) => {
  const cardCount = columns.length;

  // Render PromoCard component
  const renderPromoCard = item => {
    const Template = componentMapping[item.identifier];
    if (!Template) return null;
    return (
      <Template
        {...item}
        page={page}
        columnsLength={cardCount}
        groupRowTitle={groupRowTitle}
        restrictContent={restrictContent}
      />
    );
  };

  // Render as flex grid (matching groupRow behavior)
  return (
    <>
      {columns.map(item => (
        <Flex
          key={item.id}
          width={calculateWidth(columns)}
          justifyContent="flex-start"
          pt={[5, 11]}
          pb={[5]}
        >
          {renderPromoCard(item)}
        </Flex>
      ))}
    </>
  );
};

PromoCardGrid.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
  groupRowTitle: PropTypes.string,
  restrictContent: PropTypes.bool,
};

export default PromoCardGrid;
